import { compareUrlsBySpecificity } from 'utils/links';

import { ABOUT_US_NAVIGATION } from './pages/about';
import { DIVERSITY_EQUITY_INCLUSION_NAVIGATION } from './pages/dei';
import { FOUNDATION_NAVIGATION } from './pages/foundation';
import { INVESTORS_NAVIGATION } from './pages/investors';
import { SUSTAINABILITY_NAVIGATION } from './pages/sustainability';
import { PageNavigation } from './types';

const NAVIGATION_TREE: PageNavigation[] = [
  ABOUT_US_NAVIGATION,
  DIVERSITY_EQUITY_INCLUSION_NAVIGATION,
  SUSTAINABILITY_NAVIGATION,
  INVESTORS_NAVIGATION,
  FOUNDATION_NAVIGATION,
];

export const getSubNavigation = (
  currentPath: string
): PageNavigation | null => {
  const prioritizedNavigationTree = NAVIGATION_TREE.toSorted((navA, navB) =>
    compareUrlsBySpecificity(navA.pageUrl, navB.pageUrl)
  );
  return (
    prioritizedNavigationTree.find((nav) =>
      currentPath.startsWith(nav.pageUrl)
    ) ?? null
  );
};
